enum AnalyticsEvents {
  SIGN_IN = 'Signed In',
  SIGN_OUT = 'Signed Out',
  SIGN_UP = 'Signed Up',
  EMAIL_VERIFIED = 'Email Verified',
  EMAIL_SUBMITTED = 'Email Submitted',
  RESEND_VERIFICATION = 'Resend Verification Code Requested',
  ADMIN_SIGNUP_PAGE = 'Admin Signup Opened',
  BILLING = 'Manage billing',
  CUSTOM_FIELD_CREATED_AND_MAPPED = 'Custom Field Created & Mapped',
  SCHEDULE_ALL = 'Scheduled a route',
  DISPATCH_ROUTE = 'Dispatched a route',
  UNPUBLISH_ROUTE = 'Unpublished a route',
  DISABLE_PUBLISH_SUMMARY_MODAL = 'Disable publish summary modal',
  ORDER_MODULE_CLICKED = 'Order Module Clicked',
  CUSTOMER_MODULE_CLICKED = 'Customer Module Clicked',
  ROUTING_MODULE_CLICKED = 'Routing Module Clicked',
  DRIVER_MODULE_CLICKED = 'Driver Module Clicked',
  HELP_CLICKED = 'Help Clicked',
  WORKSPACE_SETTINGS_OPENED = 'Worskpace Settings Opened',
  ACCOUNT_MENU_OPENED = 'Account Menu Opened',
  ORG_SETTINGS_OPENED = 'Organization Settings Opened',
  INTERNAL_TOOLS = 'Internal Tools Menu Opened',
  ORDER_FILE_UPLOADED = 'Order File Uploaded',
  ORDER_FILE_UPLOAD_FAILED = 'Order File Upload Failed',
  ORDER_IMPORT_COLUMNS_MAPPED = 'Order Import Columns Mapped',
  ORDER_IMPORT_CANCELLED = 'Order Import Cancelled',
  ORDER_IMPORT_CONFIRMED_WITH_ERRORS = 'Order Import Confirmed With Errors',
  MODAL_VIEWED = 'Modal Viewed',
  SEARCH_RESULT_CLICKED = 'Search Result Clicked',
  SEARCH_PERFORMED = 'Search Performed',
  ANALYTICS_MODULE_CLICKED = 'Analytics Module Clicked',
  SETUP_COMPLETED = 'Template Setup Completed',
  SETUP_CLOSED = 'Template Setup Closed',
  INSIGHTS_MODULE_CLICKED = 'Insights Module Clicked',
  INSIGHTS_DETAILS_CLICKED = 'Insights Details Clicked',
  INSIGHTS_DETAILS_EXPORTED = 'Insights Details Exported',
  INSIGHTS_DETAILS_FILTERED = 'Insights Details Filtered',
  ROUTE_EXPORT_REQUESTED = 'Route export requested',
  ROUTE_EXPORT_FAILED = 'Route export failed',
  ROUTE_EXPORT_CANCELLED = 'Route export cancelled',
  ORDERS_CREATED = 'Orders Created',
  MAP_POPUP_SETTING = 'Stop Pin Pop-up Visibility Toggled',
  DRAW_ROUTE = 'Route Line Drawn',
  ASSIGN_DRIVER_TO_ROUTE = 'Driver Assigned to Route',
  CSV_DATE_FORMAT_DETECTED = 'CSV Date Format Detected',
  SCHEDULING_REQUESTED = 'Scheduling Requested',
  ROUTE_SETUP_REUSED = 'Route Setup Reused',
  ROUTE_SETUP_OPTION_SELECTED = 'Route Setup Option Selected',
  CUSTOMER_NOTIFICATION_TEMPLATE_EDITED = 'Customer Notification Template Edited',
  WEBHOOK_TOGGLED = 'Webhook Toggled',
  ORDERS_FILTERED = 'Orders Filtered',
  ROUTE_EDITED = 'Route Edited',
}

export default AnalyticsEvents;
